import { z } from 'zod';

import type { PageMeta } from '@/types/api';

/** Runtime validator for the {@link PageMeta} pagination block. The `z.ZodType<PageMeta>`
 *  annotation binds it to the type so the two cannot silently drift. Feature list
 *  schemas reuse this instead of re-declaring the meta object. */
export const pageMetaSchema: z.ZodType<PageMeta> = z.object({
  totalItems: z.number(),
  itemCount: z.number(),
  itemsPerPage: z.number(),
  totalPages: z.number(),
  currentPage: z.number(),
});
